import * as React from "react";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import PassForm from "../components/PassForm";
import password from "../assets/password.png";
import { Creators } from "../store/ducks/users";
import Header from "../components/Header";
import { styles } from "../theme/styles";

function MenuAppBar(props) {
  const { redirectToPasswordScreen } = props;

  return (
    <div style={styles.content}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={styles.passg}>
        {!redirectToPasswordScreen ? (
          <Typography variant="h5" color="primary" style={styles.reportestitle}>
            Cambio de Contraseña&nbsp;&nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-password-user"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#00205b"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 17v4" />
              <path d="M10 20l4 -2" />
              <path d="M10 18l4 2" />
              <path d="M5 17v4" />
              <path d="M3 20l4 -2" />
              <path d="M3 18l4 2" />
              <path d="M19 17v4" />
              <path d="M17 20l4 -2" />
              <path d="M17 18l4 2" />
              <path d="M9 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
              <path d="M7 14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2" />
            </svg>
          </Typography>
        ) : (
          <Typography variant="h5" color="primary" style={styles.reportestitle}>
            ¡Ya es momento de cambiar tu Contraseña!&nbsp;&nbsp;
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-password-user"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#00205b"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 17v4" />
              <path d="M10 20l4 -2" />
              <path d="M10 18l4 2" />
              <path d="M5 17v4" />
              <path d="M3 20l4 -2" />
              <path d="M3 18l4 2" />
              <path d="M19 17v4" />
              <path d="M17 20l4 -2" />
              <path d="M17 18l4 2" />
              <path d="M9 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
              <path d="M7 14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2" />
            </svg>
          </Typography>
        )}
        <PassForm />
        <img
          alt="Company Logo"
          src={password}
          style={styles.logoPass}
          variant="rounded"
        />
      </Grid>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    redirectToPasswordScreen: state.users.redirectToPasswordScreen,
  };
};

const creators = {
  logout: Creators.logout,
};

export default connect(mapStateToProps, creators)(MenuAppBar);
